import { AxiosInstance } from 'axios';

const isSafeStorageGrant = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'https:' && !parsedUrl.username && !parsedUrl.password;
  } catch {
    return false;
  }
};

export async function openProtectedDocument(
  accessReference: string,
  axiosInstance: AxiosInstance,
  openUrl: (url: string) => void,
): Promise<void> {
  const response = await axiosInstance.get<{ url?: string }>(accessReference, {
    headers: { Accept: 'application/json' },
  });
  const url = response.data.url;
  if (!url) {
    throw new Error('Protected document access did not return a storage grant');
  }
  if (!isSafeStorageGrant(url)) {
    throw new Error('Protected document access returned an unsafe storage grant');
  }
  openUrl(url);
}
